import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import { LanguageManager } from '@player/shared/services/language-manager.service';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { LanguageSelect } from '@player/+survey/drawer/language-select/language-select.component';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';
import { MatIcon } from '@angular/material/icon';
import { BrandName } from '@player/shared/components/brand-name/brand-name.component';
import { ShareButtons } from '@player/shared/components/share-buttons/share-buttons.component';
import { BasicModule } from '@shared/modules/basic.module';

@Component({
  selector: 'drawer-menu',
  templateUrl: './drawer-menu.component.html',
  styleUrls: ['./drawer-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatIcon, NgClass, LanguageSelect, SharedModuleForPlayer, BrandName, ShareButtons, BasicModule],
})
export class DrawerMenu {
  readonly lm = inject(LanguageManager);
  readonly ss = inject(SurveyStore);

  public selectLanguage: boolean = false;

  @Input() isAnonymous = false;

  @Output() restart: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('window:keydown.esc')
  onEscape(): void {
    this.close.emit();
  }

  onLanguagesToggle(value?: boolean): void {
    this.selectLanguage = value != null ? value : !this.selectLanguage;
  }

  flagClass(locale: string) {
    return locale && locale.length !== 2 ? 'zef-lang-other' : `zef-lang-${locale}`;
  }

  privacyPolicyLink(address: string) {
    return `https://${address}/security-and-privacy/`;
  }
}
